import React from "react";
import "./footer.scss";
import GooglePlay from "../../assets/images/google-play.webp";
import AppStore from "../../assets/images/app-store.webp";
import BrandLogoWhite from "../../assets/images/logo/brand-logo-white.svg";
import Twitter from "../../assets/images/social/twitter-white.svg";
import Instagram from "../../assets/images/social/instagram-white.svg";
import Youtube from "../../assets/images/social/youtube-white.svg";
import FooterDisclaimers from "../footerDisclaimers/footerDisclaimers";
import AboutCompany from "./aboutCompany";
import { nifty50 } from "./nifty50";

const Footer = ({ showAboutCompany, showDisclaimer }) => {
  const companyAddress = {
    addressLine1:
      "Registered office address: ",
    addressLine2:
      "Office - 2, Floor 3, Wing A, Block A, Salarpuria Softzone, ",
    addressLine3: "Bellandur Village, Varthur Hobli, ",
    addressLine4:
      "Outer Ring Road, Bangalore South, Bangalore, ",
    addressLine5: "Karnataka - 560103",
  };

  const companyLinks = {
    title: "Links",
    links: [
      {
        title: "Stocks",
        link: "/stocks",
      },
      {
        title: "WealthBaskets",
        link: "/wealthbaskets",
      },
      {
        title: "Blog",
        link: "/blog",
      },
      {
        title: "Help Center",
        link: "/support",
      },
    ],
  };

  const downloadOptions = {
    title: "Downloads",
    links: [
      {
        link:
          "https://sharemarket.onelink.me/uMHZ/s7kjbjqs",
        alt: "Download Share.Market App on Play Store",
        src: GooglePlay,
        target: "_blank",
      },
      {
        link:
          "https://sharemarket.onelink.me/uMHZ/l11hy8be",
        alt: "Download Share.Market App on App Store",
        src: AppStore,
        target: "_blank",
      },
    ],
  };

  const quickLinks = {
    title: "",
    links: [
      {
        title: "Quick Links:",
        link: "#",
      },
      {
        title: "Open Demat and Trading Account",
        link:
          "https://sharemarket.onelink.me/uMHZ/55kxncrt",
      },
    ],
  };

  const socialMediaLinks = {
    title: "",
    links: [
      {
        title: "Twitter",
        link: "https://twitter.com/SharedotMarket",
        src: Twitter,
        alt: "Twitter",
        target: "_blank",
      },
      {
        title: "Instagram",
        link: "https://www.instagram.com/sharedotmarket/",
        src: Instagram,
        alt: "Instagram",
        target: "_blank",
      },
      {
        title: "Youtube",
        link: "https://youtube.com/@SharedotMarket",
        src: Youtube,
        alt: "Youtube",
        target: "_blank",
      },
    ],
  };

  return (
    <footer className="footer">
      <div className="container-width">
        <div className="columns">
          <div className="column">
            <div className="img-wrap">
              <a href="/">
                <img
                  src={BrandLogoWhite}
                  className="logo"
                  alt="Share.Market Logo"
                />
              </a>
            </div>
            <p className="address">
              {companyAddress.addressLine1}
              {companyAddress.addressLine2}
              {companyAddress.addressLine3}
              {companyAddress.addressLine4}
              {companyAddress.addressLine5}
            </p>
          </div>
          <div className="column">
            <div className="column-wrap">
              <div className="title">
                {companyLinks.title}
              </div>
              <ul className="list">
                {companyLinks.links.map((item, index) => (
                  <li className="item" key={index}>
                    <a href={item.link}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="column">
            <div className="download-options">
              <div className="title">
                {downloadOptions.title}
              </div>
              <div className="img-wrap">
                {downloadOptions.links.map(
                  (item, index) => (
                    <a
                      href={item.link}
                      target={item.target}
                      key={index}
                    >
                      <img src={item.src} alt={item.alt} />
                    </a>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="divider"></div>
        <div className="row row-links">
          <ul className="list">
            {quickLinks.links.map((item, index) => (
              <li className="list-item" key={index}>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="row row-links">
          <ul className="list">
            <li className="list-item">
              Top Stocks By Market Capitalization:
            </li>
            {nifty50.map((item, index) => (
              <li className="list-item" key={index}>
                <a href={`/stocks/${item.slug}`}>
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="row row-media-links">
          <div className="list">
            {socialMediaLinks.links.map((item, index) => (
              <a
                className="icons"
                href={item.link}
                target={item.target}
                key={index}
              >
                <img src={item.src} alt={item.alt} />
              </a>
            ))}
          </div>
        </div>
        {showAboutCompany ? (
          <>
            <div className="divider"></div>
            <AboutCompany />
          </>
        ) : null}
        {showDisclaimer ? (
          <>
            <div className="divider"></div>
            <FooterDisclaimers />
          </>
        ) : null}
      </div>
    </footer>
  );
};

export default Footer;
